import React from 'react';

const niceStep = (range, targetTicks) => {
  if (range <= 0) return 1;
  const rough = range / targetTicks;
  const mag = Math.pow(10, Math.floor(Math.log10(rough)));
  const norm = rough / mag;
  let step;
  if (norm < 1.5) step = 1;
  else if (norm < 3) step = 2;
  else if (norm < 7) step = 5;
  else step = 10;
  return step * mag;
};

/**
 * Graphique linéaire générique (couverture % en fonction du volume de cuve testé),
 * avec grille Y, libellés X espacés, et une ligne de cible optionnelle.
 */
const SimLineChart = ({ points, yMin, yMax, color = '#000a43', targetY, yUnit = '' }) => {
  const w = 848, h = 240, padL = 50, padR = 20, padT = 20, padB = 34;
  const xs = points.map(p => p.x);
  const minX = Math.min(...xs), maxX = Math.max(...xs);
  const plotW = w - padL - padR, plotH = h - padT - padB;
  const xPos = x => padL + ((x - minX) / ((maxX - minX) || 1)) * plotW;
  const yPos = y => padT + plotH - ((y - yMin) / ((yMax - yMin) || 1)) * plotH;
  const path = points.map((p, i) => `${i === 0 ? 'M' : 'L'}${xPos(p.x).toFixed(1)},${yPos(p.y).toFixed(1)}`).join(' ');
  const tickEvery = Math.max(1, Math.ceil(points.length / 10));

  const yStep = niceStep(yMax - yMin, 5);
  const yTickStart = Math.ceil(yMin / yStep) * yStep;
  const yTicks = [];
  for (let v = yTickStart; v <= yMax + 1e-9; v += yStep) yTicks.push(v);

  return (
    <svg viewBox={`0 0 ${w} ${h}`} width="100%" height={h}>
      {yTicks.map((v, i) => {
        const y = yPos(v);
        return (
          <g key={i}>
            <line x1={padL} y1={y.toFixed(1)} x2={w - padR} y2={y.toFixed(1)} stroke="var(--color-surface-high, #f1f2f8)" />
            <text x={padL - 8} y={(y + 3.5).toFixed(1)} fontSize="10.5" textAnchor="end" fill="var(--color-on-surface-var, #5c6270)">
              {Math.round(v * 10) / 10}{yUnit}
            </text>
          </g>
        );
      })}
      <line x1={padL} y1={padT} x2={padL} y2={h - padB} stroke="var(--color-surface-highest, #e0e2eb)" />
      <line x1={padL} y1={h - padB} x2={w - padR} y2={h - padB} stroke="var(--color-surface-highest, #e0e2eb)" />
      {targetY != null && targetY >= yMin && targetY <= yMax && (
        <>
          <line x1={padL} y1={yPos(targetY)} x2={w - padR} y2={yPos(targetY)} stroke="#c9832e" strokeDasharray="4,3" />
          <text x={w - padR} y={yPos(targetY) - 5} fontSize="10.5" textAnchor="end" fill="#c9832e">{targetY}{yUnit}</text>
        </>
      )}
      <path d={path} fill="none" stroke={color} strokeWidth="2.5" />
      {points.map((p, i) => <circle key={i} cx={xPos(p.x).toFixed(1)} cy={yPos(p.y).toFixed(1)} r="3" fill={color} />)}
      {points.filter((_, i) => i % tickEvery === 0).map((p, i) => (
        <text key={i} x={xPos(p.x)} y={h - 10} fontSize="10.5" textAnchor="middle" fill="var(--color-on-surface-var, #5c6270)">{p.x}</text>
      ))}
    </svg>
  );
};

export default SimLineChart;
